import { base64string } from '../../../../../models/entities/image';

export function getExtensionFromBase64String(file: base64string) {
  return file.split(';')[0].replace('data:', '');
}
